import Quill from 'quill'

const Parchment = Quill.import('parchment')

const LetterSpacingAttributor = new Parchment.Attributor.Style('letterSpacing', 'letter-spacing', {
    scope: Parchment.Scope.INLINE
});

export { LetterSpacingAttributor };
